import AccountLinkedModal from './AccountLinkedModal';
import LinkedAccounts from './LinkedAccounts';
import LinkStatus from './LinkStatus';
import ProviderInfo from './ProviderInfo';
export const components = {
  AccountLinkedModal,
  LinkedAccounts,
  LinkStatus,
  ProviderInfo
};
flarum.reg.add('fof-oauth', 'forum/components', null);